import React from "react";
import { CalendarDays } from "lucide-react";
import ImagePreview from "../ui/ImagePreview";

const Ordercards = ({
  imgName,
  cardTitle,
  subTitle,
  orderDate,
  orderImg,
  delImg,
  mealIcon,
  mealType,
  orderNum,
  delType,
  status,
  linkTO,
  checkIcon,
  clickIcon,
}) => {
  return (
    <section className="w-full">
      <div
        className={`w-full bg-white rounded-xl  p-4 sm:p-5 shadow-sm hover:shadow-md transition-all duration-200  ${
          status === "Delivered"
            ? "border border-[#C0EBD1]" // green
            : status === "Cancelled"
              ? "border border-[#FEE4E2]" // red
              : status === "Pending"
                ? " border border-[#FEF0C7]" // dark yellow
                : ""
        }`}
      >
        <div className=" ">
          <div className="space-y-4 cursor-pointer" onClick={linkTO}>
            {/* Top Section */}
            <div className="flex flex-row  justify-between gap-3">
              <div className="flex items-center gap-3">
                <ImagePreview
                  src={imgName}
                  alt="dish"
                  className="h-12 w-12 rounded-lg object-cover shrink-0"
                />
                <h1 className="text-base sm:text-lg font-semibold text-[#303030]">
                  {cardTitle}
                </h1>
              </div>

              <span
                className={`rounded-full px-3 flex justify-center items-center text-sm font-medium w-[100px] h-[35px]
    ${
      status === "Delivered"
        ? "text-[#29B067] bg-[#C0EBD1]" // green
        : status === "Cancelled"
          ? "text-[#D92D20] bg-[#FEE4E2]" // red
          : status === "Pending"
            ? "text-[#B54708] bg-[#FEF0C7]" // dark yellow
            : ""
    }
  `}
              >
                {status}
              </span>
            </div>

            {/* Description + Price */}
            <div className="flex  flex-row  justify-between   gap-2">
              <p className="flex items-start gap-2 text-sm sm:text-base text-[#606060] leading-relaxed">
                <CalendarDays size={15} className="mt-[2px]" />
                <span className="text-black text-sm">{orderDate}</span>
              </p>

              <p className="text-base font-semibold text-[#FF6943]">
                {subTitle}
              </p>
            </div>
          </div>

          {/* Bottom Meta Info */}
          <div className="flex justify-between mt-2">
            <div className="flex flex-wrap items-center justify-start gap-3 pt-2">
              <span
                className={`flex items-center  gap-2 rounded-full  ${mealType === "dinner" ? "bg-[#B472FF]/10" : "bg-[#FF6943]/10"} px-3 py-1 text-sm text-[#191919]`}
              >
                {mealIcon}
                <p
                  className={`text-xs font-bold ${mealType === "dinner" ? "text-purple-800" : "text-[#FF6943]"}`}
                >
                  {mealType}
                </p>
              </span>
              <div className="flex items-center gap-2">
                <ImagePreview src={orderImg} alt="order" className="w-4 h-4" />
                <span>{orderNum}</span>
              </div>

              <div className="flex items-center gap-2">
                <img src={delImg} alt="delivery" className="w-4 h-4" />
                <span>{delType}</span>
              </div>
            </div>
            {checkIcon && (
              <span
                onClick={(e) => {
                  e.stopPropagation(); // 🔥 VERY IMPORTANT
                  clickIcon();
                }}
                className="flex items-center justify-center h-6 w-6 rounded-full bg-orange-500 cursor-pointer hover:bg-orange-600 transition"
              >
                {checkIcon}
              </span>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ordercards;
